
import React, { useEffect, useRef, useState } from 'react';
// import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from '../../FormFields/DatePicker';





const MessageA22 = (props) => {
    const presentDate =  new Date().getDate()+"/"+(new Date().getMonth()+1)+"/"+new Date().getFullYear();
    const data = {"key1":presentDate,"key2":presentDate}
    const [dateSelect, setDateSelect] = useState({})
    const initialDate1= props.userInputObj && props.userInputObj.key1;
    const initialDate2= props.userInputObj && props.userInputObj.key2;


     
    if (dateSelect && Object.keys(dateSelect).length === 0) {
        // console.log("dateSelect", dateSelect)
        localStorage.setItem("inputValue", JSON.stringify(data))
    }

         const dateData1 = props.item && props.item.text_data &&  props.item.text_data.date1;
         const dateData2 = props.item && props.item.text_data &&  props.item.text_data.date2;
   
   
    //  console.log("presentDate",props,dateData1,dateData2, props.item.text_data )
   
   
    const parentCallback = (data,type) =>{
       
        setDateSelect({...dateSelect,[type]:data})
        // console.log("parentCallback",data,({...dateSelect,[type]:data}))
        // localStorage.setItem('inputValue', JSON.stringify(({...dateSelect,[type]:data})));

   
        var existing = localStorage.getItem('inputValue');
        existing = existing ? JSON.parse(existing) : {};
        existing[type] =data;
        localStorage.setItem('inputValue', JSON.stringify(existing));
     

    }

    return (
        <>
          <div >
           <div  >  <DatePicker {...props} message="Start Date" parentCallback={parentCallback} type="key1" dateData={dateData1} initialDate={initialDate1} /></div>
           <div > <DatePicker {...props} message="End Date" parentCallback={parentCallback} type="key2" dateData={dateData2}  initialDate={initialDate2} /></div>
            </div>
        </>

    )
}

export default MessageA22;
